import CoveoSearchInput from "@DSG/Widgets/Coveo/Header/CoveoSearchInput";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";

export const CoveoHeaderSearchInput: React.FC<WidgetProps> = ({ id }) => {
    return (
        <>
            <CoveoSearchInput id={id} />
        </>
    ) 
};

const widgetModule: WidgetModule = {
    component: CoveoHeaderSearchInput,
    definition: {
        group: "Header",
        displayName: "Coveo Search Input",
        allowedContexts: ["Header"],
    },
};

export default widgetModule;
